module.exports = __webpack_public_path__ + "static/WholeBarleyFlour-b964cdae5751a3675885d30523a8c0c2.webp";